// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Se1tz"};